import '@boomi/exosphere/dist/styles.css';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import './main.css';
import AppRoot from './AppRoot';

// Need to import exosphere icons separately
// https://exosphere.boomi.com/?path=/docs/miscellaneous-migrate-to-7-x-x--overview#migrating-to-7xx
import '@boomi/exosphere/dist/icon.js';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <BrowserRouter>
            <AppRoot />
        </BrowserRouter>
    </StrictMode>,
);
